import { ORDER_METHODS } from '../../../../services/exports/Constants';

export default {
  text: {
    thank_you: 'Gracias, {{name}}',
    confirmation_email:
      'Recibirás pronto un correo de confirmación con tu número de pedido de nuestro socio tecnológico {{provider_email}}',
    need_help: '¿Necesitas ayuda?',
  },
  labels: {
    order_number: 'Nº de pedido: {{number}}',
    order_number_short: '#{{number}}',
    today: 'Hoy',
    was_prefix: 'antes',
    restaurant: 'Restaurante',
    order_details: 'Detalles del pedido',
    your_details: 'Tus datos',
    contact: 'Contacto',
    payment: 'Pago',
    payment_method: 'Método de pago',
    delivery: 'Entrega',
    delivery_details: 'Detalles de entrega',
    pickup_details: 'Detalles de recogida',
    pickup_instruction: '📋 Indícanos tu número de pedido {{number}} al recoger tu pedido.',
    billing_info: 'Información de facturación',
    order_note: 'Nota del pedido',
    order_summary: 'Resumen del pedido',
    help: '¿Necesitas ayuda? Contáctanos {{phone_number}}',
  },
  status: {
    canceled: 'Pedido cancelado',
    received: 'Pedido recibido',
    confirmed: '¡Pedido confirmado!',
  },
  eta: {
    min_label: 'MIN',
  },
  order_methods: {
    [ORDER_METHODS.PICKUP]: 'Recogida',
    [ORDER_METHODS.DELIVERY]: 'Entrega',
    [ORDER_METHODS.ON_SITE]: 'Pedido en mesa',
  },
  rewards: {
    member: {
      pill_title: 'Puntos ganados',
      from_order: 'puntos de este pedido',
      total_balance: 'Saldo total',
      reward_value: 'Valor de la recompensa',
      redeem_hint: '✓ Puedes canjear hasta {{points}} pts ({{amount}}) en tu próximo pedido',
      points_to_redeem: 'Solo necesitas {{points}} puntos más para canjear tu recompensa',
    },
    guest: {
      pill_title: 'Recompensas',
      earned_heading: 'Has ganado <highlight>{{points}} puntos</highlight> en este pedido',
      worth_on_next: 'Vale <strong>{{amount}}</strong> en tu próximo pedido',
      ready_to_claim: 'Listo para reclamar',
      next_order_discount: 'Descuento en el próximo pedido',
      claim_cta: 'Reclama tus {{points}} pts — regístrate gratis',
      claim_note: '30 segundos · tus puntos se acreditan al instante',
    },
  },
  buttons: {
    back_to_menu: 'Volver al menú',
    back_to_checkout: 'Volver al pago',
    contact_us: 'Contáctanos {{phone_number}}',
    try_again: 'Reintentar',
  },
  loading: {
    processing_payment: 'No abandones la página mientras procesamos tu pago',
  },
  success_messages: {
    order_placed: {
      title: '✅ ¡Pedido realizado con éxito!',
      description: 'Tu pedido se ha realizado con éxito.',
    },
  },
  error_messages: {
    failed_to_load: 'No se pudo cargar el pedido. Por favor, inténtalo de nuevo.',
    payment_failed: 'Pago fallido, por favor inténtalo de nuevo',
  },
  load_failed: {
    title: 'No pudimos cargar tu pedido',
    description:
      'Algo salió mal al cargar los detalles de tu pedido. Inténtalo de nuevo. Si sigue ocurriendo, contacta con soporte y te ayudaremos de inmediato.',
  },
};
